import { sendFileMessage } from './sendFileMessage';
import { EUploadFilesStatus, TMessageFiles } from '../../types/file';
import { EMessageType } from '../../types/messages';
import { TThunkAction } from '../../types/redux/thunk';
import { createOutcomingMessage } from '../../utils/messageUtils';
import { setSendMessagePending } from '../sendMessage';
import { sendWsMessage } from '../wsMessage';

type TRetrySendFileMessage = {
  pendingFiles: TMessageFiles;
  chatId: string;
  messageId: string;
};

export const retrySendFileMessage =
  ({ chatId, messageId, pendingFiles }: TRetrySendFileMessage): TThunkAction<void> =>
  async (dispatch, getState, context) => {
    const {
      user: { userId },
    } = getState();

    // Если загрузка файла отвалилась на шаге 1 при отправке в мск files
    if (pendingFiles.status === EUploadFilesStatus.Failed && pendingFiles.blobFiles?.length) {
      const file = pendingFiles.blobFiles[0].file;
      const type = pendingFiles.blobFiles[0].type;

      dispatch(sendFileMessage({ file, chatId, type, messageId }));

      return;
    }

    // Если загрузка файла отвалилась на шаге 2 при отправке по сокету
    if (pendingFiles.status === EUploadFilesStatus.Succeed && pendingFiles.uploadedFiles?.length) {
      const message = createOutcomingMessage({ uid: messageId, type: EMessageType.TextAndFiles, chatId, userId });

      dispatch(setSendMessagePending({ message, messageId, messagesMap: context.custom.messagesMap }));
      dispatch(sendWsMessage({ message, files: pendingFiles.uploadedFiles }));

      return;
    }
  };
